<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
          <i class="fas fa-user-alt"></i>
          User information
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">User</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <div slot="header">
        <strong>User information</strong>
        <small v-if="!add && model.last_visit"> Last Login at ({{model.last_visit | sdate}} @ {{model.last_addr}})</small>
      </div> -->
      <b-row class="mb-2">
        <b-col class="title">
          User information
          <span class="label_sub" v-if="!add && model.last_visit"> Last Login at ({{model.last_visit | sdate}} @ {{model.last_addr}})</span>
        </b-col>
      </b-row>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-form-label" md="2">
          Available
        </b-col>
        <b-col>
          <div class="col-xl-4 col-md-12  d-flex align-self-center">
            <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox"  v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
            </div>
          </div>
        </b-col>
        <b-col class="col-form-label" md="2" v-show="!add">
          Last visit
        </b-col>
        <b-col v-show="!add">
          <b-input type="text" :value="last_info" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-form-label" md="2">
          Permissions
        </b-col>
        <b-col md="4">
          <v-select v-if="!lock" label="name" v-model="model.permissions" :options="codes.permissions_user"></v-select>
          <b-input type="text" v-if="lock" :value="model.permissions" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-form-label" md="2">
          Username(ID)
        </b-col>
        <b-col md="4">
          <b-input type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-input>
        </b-col>
        <b-col class="col-form-label" md="2">
          Nickname
        </b-col>
        <b-col md="4">
          <b-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-input>
        </b-col>
      </b-row>

      <b-row v-show="add || !lock" class="mb-2">
        <b-col md="2" class="col-form-label">
          {{add ? 'Use' : 'Change'}} Password(*)
        </b-col>
        <b-col md="4">
          <b-form-group>
            <b-form-input type="password" id="ph_pass" v-model="model.new__password" :plaintext="lock"></b-form-input>
            <b-badge v-if="model.new__password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
            <b-badge v-if="model.new__password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
            <b-badge v-if="model.new__password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
            <b-badge v-if="model.new__password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
            <b-badge v-if="model.new__password"  :variant="password_policy('length') ? 'success' : 'danger'">
              Min Length : {{password_meter.min_length}}
            </b-badge>
          </b-form-group>
        </b-col>
        <b-col class="col-form-label" md="2" v-if="model.new__password">
          Retype Password
        </b-col>
        <b-col v-if="model.new__password">
          <b-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-input>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col class="col-form-label" md="2">
          List of allowed IPs
        </b-col>
        <b-col md="10">
          <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
        </b-col>
      </b-row>
      <hr>
      <!-- <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Available" label-for="ph_use">
            <c-switch color="info" label v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="model.id">
          <b-form-group class="text-primary">
            <label>Last visit</label>
            <b-input type="text" :value="last_info" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_group">Permissions</label>
            <v-select v-if="!lock" label="name" v-model="model.permissions" :options="codes.permissions_user"></v-select>
            <b-input type="text" v-if="lock" :value="model.permissions" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_username">Username (Login)</label>
            <b-input type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group class="text-primary">
            <label for="ph_nickname">Nickname</label>
            <b-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group class="text-primary">
            <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
            <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row> -->
      <!-- <b-row>
        <b-col md="4">
          <b-form-group>
            <label for="ph_timezone">Timezone</label>
            <b-input type="text" id="ph_timezone" v-model="model.timezone" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="ph_country">Country</label>
            <b-input type="text" id="ph_country" v-model="model.country" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="ph_language">Language</label>
            <b-input type="text" id="ph_language" v-model="model.language" :plaintext="lock"></b-input>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col md="10" class="text-left">
          <template v-if="lock">
            <b-button variant="primary" @click="edit" class="btn-add"> Modify </b-button>
            <b-button variant="danger" @click="confirm = true"> Delete </b-button>
          </template>
          <template v-else>
            <b-button class="btn-add" variant="success" @click="save"> Save </b-button>
            <b-button variant="secondary" @click="cancel" class="btn-cancel"> Cancel </b-button>
          </template>
        </b-col>
        <b-col md="2" class="text-right">
          <b-button variant="secondary" class="btn-addition mr-2" @click="back"> List </b-button>
        </b-col>
      </b-row>
    </b-card>
    <hr>
    <logList v-if="model.id" :user_id="model.id" />
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
